export default "Another car preview!";